// Tenant-aware routing helpers. The public site renders under three bases:
//   /s/:slug   (multi-tenant public site)
//   /g/:token  (private guest portal)
//   /paelbi    (legacy demo)
// All navigation is resolved relative to the current base — no hardcoded slugs.
import { useLocation } from 'react-router-dom';

export function tenantBaseFromPath(pathname = '') {
  let m = pathname.match(/^\/s\/([^/]+)/);
  if (m) return `/s/${m[1]}`;
  m = pathname.match(/^\/g\/([^/]+)/);
  if (m) return `/g/${m[1]}`;
  if (pathname.startsWith('/paelbi')) return '/paelbi';
  return '/paelbi';
}

// Rewrite a logical path (absolute '/paelbi/...' or bare segment) onto the base.
export function toTenantPath(rawPath, base) {
  if (!rawPath || rawPath === '/paelbi') return base;
  if (rawPath.startsWith('/paelbi/')) return base + rawPath.slice('/paelbi'.length);
  if (rawPath.startsWith('/')) return rawPath;
  return `${base}/${rawPath}`;
}

export function publicSlugFromPath(pathname = '') {
  const m = pathname.match(/^\/s\/([^/]+)/);
  return m ? decodeURIComponent(m[1]) : (process.env.REACT_APP_TENANT_SLUG || 'paelbi');
}

export function useTenantBase() {
  const { pathname } = useLocation();
  return tenantBaseFromPath(pathname);
}
